import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { AuthActions } from '@redux';

export const useBiometricLabels = (email, isBiometric) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [fieldLabel, setFieldLabel] = useState(t('question_number_and_code'));
  const [fieldTooltip, setFieldTooltip] = useState(t('question_number_and_code_tooltip'));

  useEffect(() => {
    if (!isBiometric || !email) {
      setIsLoading(false);
      return;
    }

    const fetchBiometricsData = async () => {
      setIsLoading(true);
      try {
        const result = await dispatch(AuthActions.getBiometricsData(email));
        const payload = result?.payload;
        if (payload === true) {
          setFieldLabel(t('question_person_code'));
          setFieldTooltip(t('question_person_code_tooltip'));
        } else if (payload === false) {
          setFieldLabel(t('question_document_number'));
          setFieldTooltip(t('question_document_number_tooltip'));
        } else {
          setFieldLabel(t('question_number_and_code'));
          setFieldTooltip(t('question_number_and_code_tooltip'));
        }
      } catch (error) {
        setFieldLabel(t('question_number_and_code'));
        setFieldTooltip(t('question_number_and_code_tooltip'));
      } finally {
        setIsLoading(false);
      }
    };

    fetchBiometricsData();
  }, [email, isBiometric, t, dispatch]);

  return { fieldLabel, fieldTooltip, isLoading };
};
